import { WidgetComingSoon } from 'features/widgets/Widget';

const CompanyUsers = () => {
  return <WidgetComingSoon title='Company Users' />;
};

export default CompanyUsers;
